export const sweetMessages = [
  "Hans sayang, take your time yaa. ellyn di sini terus kok ",
  "ndaa usah buru buru, love. Aku tunggu kamu sampe kapan pun kok ❤️",
  "Feelings kamu ituu valid banget, Hans sayang. Take all the time you need yahh, ellyn ngerti kok🌸",
  "Kalo butuh space, gapapa bgt sayangku. Aku respect & still love you so much 💝",
  "Hans sayang, it’s okay to not be okay yahh. Aku di sini, always 🫂",
  "Breathe dulu pelan pelan yaa sayang. Everything’s gonna be fine, trust me okay?🌟",
  "You’re strong as hell, Hans sayangg. Aku proud of you, always 💪💕",
  "Kamu nda akan pernahh sendirian, Hans sayang ku. Even when you need me from a distance, aku akan slalu ada untuk kamu ",
  "Your feelings matter, sayang",
  "Hans sayang, you deserve peace & quiet. Ambil waktu sebanyak yang kamu perlu yahh?",
  "Aku cinta kamu apa adanya mau itu bad days, quiet days, everything 💗",
  "This too shall pass, sayang. Aku di sini, temenin kamu sampe better yahh",
  "Hans, you’re amazing even on days you feel like zero. lowvee ywouu",
  "Pelan-pelan aja, love. Life’s not a race, we got time kok",
  "Kalo hans sayang ngerasa capee, istirahat yang banyak yahh! Aku jaga kamu dari jauh pake doa & cintaaaa zizizizii",
  "Mental health > everything, Hans. Prioritize yourself dulu yaa sekarang? ",
  "Boleh nangis, boleh diam, boleh ngerasa semuanya ndabaik baik ajaa karenaa itu semua manusiawi, sayangku ",
  "Aku proud of you for choosing to heal, Hans. That’s real strength 🌟",
  "Whatever you’re feeling right now? Valid 100%. No judgment here okay? lowvee ywouu",
  "Gak usah jelasin apa-apa ke aku. Aku akan slalu ngerti perasaan kamu hans sayang",
  "Take your time, love",
  "Aku tetap di sini yah?",
  "Hans, you’re doing way better than you think. proudd off hansi ku sayang",
  "You deserve all the peace, calm, and softness in the world !!",
  "Be gentle sama diri sendiri yaaa Hans ku tersayang. You’re already doing your best",
  "You’re loved. You’re seen. You matter especially to me 💖",
  "Put yourself first sometimes, Hans. Aku 100% support that cintakuu",
  "Gak perlu strong terus, sayang. It’s okay to just… be",
  "Aku appreciate banget kamu jujur butuh space. That’s brave sayang. takee ur time yah!!",
  "Take all the space you need, love. Aku respect your boundaries kesayangan kuuu lowvee ywouuu hansi ku",
  "You’re allowed to feel everything, Hans sayangku. No filter needed oka oka??? ",
  "ndaaa usah pura-pura oke di depan aku. sini sinii ellynn peluk kamu dari jauh ",
  "Aku proud of you for choosing yourself untukk tenang duluu Hans sayang ",
];

// Function to get a random message
export const getRandomMessage = () => {
  const randomIndex = Math.floor(Math.random() * sweetMessages.length);
  return sweetMessages[randomIndex];
};